import { FC } from "react"
import { SchedulesList } from "../../../module/schedules/containers/list"

export const SchedulesListPage: FC = () => <SchedulesList />
